import STACK_CONFIG from './config/BuildStack.json'

export const styles = theme => ({
    button: {
        margin: '8px',
    }, root: {
        display: "flex",
        flexWrap: "wrap"
    }, margin: {
        margin: '8px'
    },
    formControl: {
        minWidth: '194px'
    },
    marginLeft :{
        marginLeft: '8px'
    },withoutLabel: {
        marginTop: '8px' * 3
    }, textField: {
        flexBasis: 200
    }, topBarButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
    }, toggleMapButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
        width: '817px'
    }, plainWhiteButton: {
        color: '#000',
        borderWidth: 'thin',
        backgroundColor: '#ffffff',
        width: '200px'
    }, clearPolygonButton: {
        color: '#000',
        borderWidth: 'thin',
        '&:hover': {
          backgroundColor: '#EE5353',
          // borderColor: '#B2B2B2',
        },
        // backgroundColor: '#EE5353',
    }, mapContainer: {
        backgroundColor: '#ebf0f4',
        borderStyle: 'solid',
        borderColor:'#4589b6',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }, metOptionsContainer: {
        width: '815px',
    }, toggleAdvancedOptionsButton: {
        // color: '#212121',
        // borderColor: '#878787',
        // borderWidth: 'thin',
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: '#EDEDED',
          borderColor: '#B2B2B2',
        },
        width: '817px'
    }
    , advancedOptionsContainer: {
        // backgroundColor: '#EDEDED',
        borderBottomStyle: 'solid',
        borderLeftStyle: 'solid',
        borderRightStyle: 'solid',
        borderColor:'#B2B2B2',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }
});

export const stackInit = {
    'source' : {
        stackName: "",
        emissionType: "",
        latUTMx: null,
        lonUTMy: null,
        height: null,
        diameter: null,
        exitTemperature: null,
        exitVelocity: null,
        areaX:null,
        areaY:null,
        anga:null,
        longtermNO2: 0,
        longtermSO2: 0,
        longtermPM25: 0,
        longtermPM10: 0,
        longtermLead: 0,
        longtermCO: 0,
        longtermOther: 0,
        shorttermNO2: 0,
        shorttermSO2: 0,
        shorttermPM25: 0,
        shorttermPM10: 0,
        shorttermLead: 0,
        shorttermCO: 0,
        shorttermOther: 0
    }
}

export function validateRequestBody(formInputs) {
    let mcErrorA = false
    let mcErrorYr = false
    let mcErrorH = false
    let mcErrorLL = false
    let mcErrorS = false
    let mcErrorStN = false
    let mcParamsA = []
    let mcParamsH = []
    let checkSource = true

    let regex = new RegExp(/^[\w-\s]+$/)
    let mcErrorregex = regex.test(formInputs['modelDescription'])
    console.log(mcErrorregex)
    if (!mcErrorregex){
        return "Project Description only allows the special characters: spaces, hyphens, and underscores."
    }

    if (formInputs['runOption']==="met"){
        checkSource = false
    }

    if (formInputs['endYear']-formInputs['startYear'] > 4){
        mcErrorYr = true
        formInputs['startYear']= formInputs['endYear'] - 4
    }

    if (checkSource){
        mcErrorA = true
        mcErrorH = true

        Object.keys(formInputs["source"])
            .forEach(key => {
                if (!formInputs["source"][key]['stackName'] || !formInputs["source"][key]['emissionType']){
                    mcErrorS= true
                }else{
                    formInputs["source"][key]['emissionType']=formInputs["source"][key]['emissionType'].toUpperCase()
                    console.log(formInputs["source"][key]['emissionType'])

                    if (formInputs["source"][key]['emissionType']==='P' && (!formInputs["source"][key]['stackName'] || !formInputs["source"][key]['latUTMx'] || !formInputs["source"][key]['lonUTMy'] ||
                     !formInputs["source"][key]['height'] || !formInputs["source"][key]['diameter'] || !formInputs["source"][key]['exitTemperature'] ||
                     !formInputs["source"][key]['exitVelocity'])){
                        mcErrorS= true
                    }else if (formInputs["source"][key]['emissionType']==='A' && (!formInputs["source"][key]['stackName'] || !formInputs["source"][key]['latUTMx'] || !formInputs["source"][key]['lonUTMy'] ||
                     !formInputs["source"][key]['height'] || !formInputs["source"][key]['areaX'] || !formInputs["source"][key]['areaY'] || !formInputs["source"][key]['anga'])){
                        mcErrorS= true
                    }
                    if  (formInputs['aermodStackSourceLocationFile'] && formInputs['aermodStackSourceLocationFile']!=="NONE"){
                        mcErrorS= false
                    }
        }})

        Object.keys(formInputs["source"])
            .forEach(key => {
                let stkLat = Math.abs(parseFloat(formInputs["source"][key]['latUTMx'])- formInputs['latitude'])
                let stkLon = Math.abs(parseFloat(formInputs["source"][key]['lonUTMy'])- formInputs['longitude'])
                console.log(stkLat)
                console.log(stkLon)
                if (formInputs["source"][key]['stackName'].includes(' ') || formInputs["source"][key]['stackName'].includes('-') || formInputs["source"][key]['stackName'].includes('.')){
                    mcErrorStN = true
                }
                if (stkLat > 0.3 || stkLon > 0.3){
                    mcErrorLL = true
                }
                if  (formInputs['aermodStackSourceLocationFile']  && formInputs['aermodStackSourceLocationFile']!=="NONE"){
                    mcErrorLL= false
                }
        })

        STACK_CONFIG.stack['source'].forEach(item => {
            if (item['name'] === "Annual Emissions"){
                item['values'].forEach(value => {
                    mcParamsA.push(value.value)
                })
            }
        })

        Object.keys(formInputs["source"])
            .forEach(key => {
                mcParamsA.forEach(mcEmission =>{
                    if (formInputs["source"][key][mcEmission] > 0 || (formInputs['aermodStackSourceLocationFile'] &&
                        formInputs['aermodStackSourceLocationFile']!=="NONE")){
                            mcErrorA = false
                        }
                    if (formInputs["source"][key][mcEmission] ===""){
                        formInputs["source"][key][mcEmission]=0
                    }
                })
        })

        STACK_CONFIG.stack['source'].forEach(item => {
            if (item['name'] === "Hourly Emissions"){
                item['values'].forEach(value => {
                    mcParamsH.push(value.value)
                })
            }
        })

        Object.keys(formInputs["source"])
            .forEach(key => {
                mcParamsH.forEach(mcEmission =>{
                    if (formInputs["source"][key][mcEmission] > 0 || (formInputs['aermodStackSourceLocationFile'] &&
                        formInputs['aermodStackSourceLocationFile']!=="NONE")){
                            mcErrorH = false
                        }
                })
        })
    }

    let mcErrorHrly = false
    if (formInputs['hourlyEmissionsDataFile'] !== null && !formInputs['hourlyEmissionsDataFile'].endsWith('.emi') && formInputs['hourlyEmissionsDataFile'] !== "NONE"){
            mcErrorHrly=true
    }
    if (mcErrorStN){
            return "Stack name must be alphanumeric with no spaces"
    }else if (mcErrorS){
        return "Please fill out the necessary source parameters"
    }else if (mcErrorLL){
        return "Your source must be near your facility"
    }else if (mcErrorA){
        return "At least one annual Emission must be > 0"
    } else if (mcErrorH){
        return "At least one hourly Emission must be > 0"
    } else if (!formInputs['useDefaultMetCheck'] && !formInputs['wrfAndMMIF'] && (!formInputs['onsiteMeteorologicalDataFile'] ||
        formInputs['onsiteMeteorologicalDataFile']==="NONE") && (JSON.parse(formInputs['selectedSurfaceStation']).name === "today" ||
        JSON.parse(formInputs['selectedUpperAirStation']).name === "today" ) && (!formInputs['previousMet'] || formInputs['previousMet']==="NONE" )){
        return 'Please select a valid Meteorological option'
    } else if (!formInputs['latitude'] || !formInputs['longitude']){
        return 'Please provide project coordinates'
    } else if (!formInputs['modelDescription']){
        return 'Please provide a project description'
    } else if (!formInputs['startYear']){
        return 'Please provide a project start year'
    } else if (!formInputs['endYear']){
        return 'Please provide a project end year'
    } else if (parseInt(formInputs['startYear']) > parseInt(formInputs['endYear'])){
        return 'Please provide a project start year that is before the end year'
    } else if (!formInputs['stateACRONYM']){
        return 'Please provide the project state'
    } else if (!formInputs['no2'] && !formInputs['so2'] && !formInputs['pm25'] &&
            !formInputs['pm10'] && !formInputs['lead'] && !formInputs['co'] && !formInputs['other'] ){
        return 'Please select at least one pollutant'
    } else if ((formInputs['onsiteMeteorologicalDataFile'] && formInputs['onsiteMeteorologicalDataFile']!=="NONE") &&
                (!formInputs['osLat'] || !formInputs['osLon'] || !formInputs['osElev'])){
        return 'Please provide more onsite station information'
    }else if (formInputs['onsiteMeteorologicalDataFile'].endsWith('.txt') || formInputs['onsiteMeteorologicalDataFile'].endsWith('.dat')){
        return 'Onsite file must end with ".txt" or ".dat"'
    }else if (mcErrorHrly){
        return 'Hourly emissions file must end with ".emi"'
    }
}

export function translateRequestBody(formInputs) {
    let requestBody = {
        "MODEL": formInputs["model"],
        "DESCRIPTION": formInputs["modelDescription"],
        "AERSFC_1": formInputs["aersurfaceJan"],
        "AERSFC_2": formInputs["aersurfaceFeb"],
        "AERSFC_3": formInputs["aersurfaceMar"],
        "AERSFC_4": formInputs["aersurfaceApr"],
        "AERSFC_5": formInputs["aersurfaceMay"],
        "AERSFC_6": formInputs["aersurfaceJun"],
        "AERSFC_7": formInputs["aersurfaceJul"],
        "AERSFC_8": formInputs["aersurfaceAug"],
        "AERSFC_9": formInputs["aersurfaceSep"],
        "AERSFC_10": formInputs["aersurfaceOct"],
        "AERSFC_11": formInputs["aersurfaceNov"],
        "AERSFC_12": formInputs["aersurfaceDec"],
        "AERSFC_CHECK": formInputs["useAersurfaceCategories"],
        "AERSFC_yr1P": formInputs["asfc_yr1P"],
        "AERSFC_yr2P": formInputs["asfc_yr2P"],
        "AERSFC_yr3P": formInputs["asfc_yr3P"],
        "AERSFC_yr4P": formInputs["asfc_yr4P"],
        "AERSFC_yr5P": formInputs["asfc_yr5P"],
        "AERSFC_PRECIP_CHECK": formInputs["useAersurfacePrecip"],
        "ADJ_U": formInputs["adjU"],
        "SPLITAERMOD": formInputs["splitAermod"],
        "HOURLY_FILE": formInputs["hourlyEmissionsDataFile"],
        "BLDG_FILE": formInputs["buildingLocationFile"],
        "CO_CHECK": formInputs["co"],
        "FENCE_FILE": formInputs["fenceLineLocationFile"],
        "ISR": formInputs["inStackRatio"],
        "LEAD_CHECK": formInputs["lead"],
        "MMIF_CHECK": formInputs["wrfAndMMIF"],
        "NO2_CHECK": formInputs["no2"],
        "ONSITE_FILE": formInputs["onsiteMeteorologicalDataFile"],
        "ONSITE_LAT": formInputs["osLat"],
        "ONSITE_LON": formInputs["osLon"],
        "ONSITE_ELEV": formInputs["osElev"],
        "OTHER_CHECK": formInputs["other"],
        "OZONE_VAL": formInputs["backgroundOzoneValue"],
        "STARTYEAR":formInputs["startYear"],
        "ENDYEAR":formInputs["endYear"],
        "STMET":formInputs["stmet"],
        "PM10_CHECK": formInputs["pm10"],
        "PM25_CHECK": formInputs["pm25"],
        "REC_G1LB": formInputs["grid1LowerBoundary"],
        "REC_G1S": formInputs["grid1Spacing"],
        "REC_G1UB": formInputs["grid1UpperBoundary"],
        "REC_G2LB": formInputs["grid1UpperBoundary"],
        "REC_G2S": formInputs["grid2Spacing"],
        "REC_G2UB": formInputs["grid2UpperBoundary"],
        "REC_G3LB": formInputs["grid2UpperBoundary"],
        "REC_G3S": formInputs["grid3Spacing"],
        "REC_G3UB": formInputs["grid3UpperBoundary"],
        "RUN_OPT": formInputs["runOption"],
        "SFC_MET_OPT": formInputs["selectedSurfaceStation"],
        "SO2_CHECK": formInputs["so2"],
        "STATE": formInputs["stateACRONYM"].toUpperCase(),
        "STACK_NO": Object.keys(formInputs["source"]).length,
        "STK1": [],
        "STK1L": [],
        "STK1S": [],
        "STK_FILE": formInputs["aermodStackSourceLocationFile"],
        "SENSITIVE_REC": formInputs["sensitiveRecCheck"],
        "UPA_MET_OPT": formInputs["selectedUpperAirStation"],
        "FIND_MET": formInputs["useDefaultMetCheck"],
        "USRLAT": formInputs["latitude"],
        "USRLON": formInputs["longitude"],
        "BUILDING_GEOJSON": formInputs["buildingGeojson"],
        "FENCELINE_GEOJSON": formInputs["fencelineGeojson"],
        "DRAWN_BUILDINGS": formInputs["drawnBuildings"],
        "DRAWN_FENCELINES": formInputs["drawnFencelines"],
        "PREVIOUSMET": formInputs["previousMet"],
    };

    Object.keys(formInputs["source"])
        .forEach(key => {
            requestBody["STK1"].push([
                formInputs["source"][key]['stackName'],
                formInputs["source"][key]['emissionType'],
                formInputs["source"][key]['latUTMx'],
                formInputs["source"][key]['lonUTMy'],
                formInputs["source"][key]['height'],
                formInputs["source"][key]['diameter'],
                formInputs["source"][key]['exitTemperature'],
                formInputs["source"][key]['exitVelocity'],
                formInputs["source"][key]['areaX'],
                formInputs["source"][key]['areaY'],
                formInputs["source"][key]['anga'],
            ]);
            requestBody["STK1L"].push([
                formInputs["source"][key]['longtermNO2'],
                formInputs["source"][key]['longtermSO2'],
                formInputs["source"][key]['longtermPM25'],
                formInputs["source"][key]['longtermPM10'],
                formInputs["source"][key]['longtermLead'],
                formInputs["source"][key]['longtermCO'],
                formInputs["source"][key]['longtermOther'],
            ])
            requestBody["STK1S"].push([
                formInputs["source"][key]['shorttermNO2'],
                formInputs["source"][key]['shorttermSO2'],
                formInputs["source"][key]['shorttermPM25'],
                formInputs["source"][key]['shorttermPM10'],
                formInputs["source"][key]['shorttermLead'],
                formInputs["source"][key]['shorttermCO'],
                formInputs["source"][key]['shorttermOther'],
            ])
    })

    return requestBody
}
